import { render, staticRenderFns } from "./RewriteModal.vue?vue&type=template&id=5645aeb0&scoped=true&"
import script from "./RewriteModal.vue?vue&type=script&lang=js&"
export * from "./RewriteModal.vue?vue&type=script&lang=js&"
import style0 from "./RewriteModal.vue?vue&type=style&index=0&id=5645aeb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5645aeb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
